import React from 'react';
import { Outlet } from 'react-router-dom';
import GlobalNav from '../components/GlobalNav';
import Footer from '../components/Footer';

export default function SiteLayout() {
  return (
    <>
      <GlobalNav />
      <main className="site-main">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

